import { useMemo } from 'react';

export const useCommitteeData = (
  coiData,
  candidateArray,
  committeeData,
  fellowsArray,
  nonAasRefereesArray,
) =>
  useMemo(() => {
    if (!coiData.length || !candidateArray.length || !committeeData) {
      return { candidates: [], committeeMembers: [] };
    }

    const uniqueCandidateIds = [
      ...new Set(coiData.map((coi) => coi.attributes.candidateId)),
    ];

    const candidates = uniqueCandidateIds
      .map((candidateId) => {
        const candidate = candidateArray.find((c) => c.id === candidateId);
        return {
          id: candidateId,
          name: candidate
            ? `${candidate.attributes.name || ''} ${candidate.attributes.lastName || ''}`.trim()
            : `Candidate ${candidateId}`,
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));

    const getMemberName = (member) => {
      let memberName = `User ${member.id}`;

      if (member.attributes.fellowId) {
        const fellow = fellowsArray.find(
          (f) => f.id === member.attributes.fellowId,
        );
        if (fellow) {
          memberName =
            `${fellow.attributes.name} ${fellow.attributes.lastName}`.trim();
        }
      } else if (member.attributes.nonAasRefereeId) {
        const referee = nonAasRefereesArray.find(
          (r) => r.id === member.attributes.nonAasRefereeId,
        );
        if (referee) {
          memberName =
            `${referee.attributes.name} ${referee.attributes.lastName}`.trim();
        }
      }

      return memberName;
    };

    const committeeMembers = [];

    // Add chair
    if (committeeData?.attributes?.committeeChair?.data) {
      const chair = committeeData.attributes.committeeChair.data;
      committeeMembers.push({
        id: chair.id,
        name: getMemberName(chair),
        isChair: true,
      });
    }

    // Add members
    if (committeeData?.attributes?.committeeMembers?.data) {
      committeeData.attributes.committeeMembers.data.forEach((member) => {
        if (!committeeMembers.find((m) => m.id === member.id)) {
          committeeMembers.push({
            id: member.id,
            name: getMemberName(member),
            isChair: false,
          });
        }
      });
    }

    return { candidates, committeeMembers };
  }, [
    coiData,
    candidateArray,
    committeeData,
    fellowsArray,
    nonAasRefereesArray,
  ]);
